
export enum LayoutType {
  SMALL = 10,
  MEDIUM = 20,
  LARGE = 30,
  XLARGE = 40
}
export enum LayoutBreakPoint {
  DYNAMIC = 0,
  SMALL = 740,
  MEDIUM = 1020,
  LARGE = 1280
}

export const primaryRelatedWidth = 256;
export const widthCorrection = -60; // Hint: Parent Magnolia component margin. Should better be dynamic.

export default class MainLayoutInfo {

  public static getGlobalMarginH(layoutType: LayoutType) {

    switch(layoutType) {
      case LayoutType.SMALL: return 20;
      case LayoutType.MEDIUM: return 0;
      case LayoutType.LARGE: return 0;
      default:
      case LayoutType.XLARGE: return 0;
    }
  }

  public static getLayoutType(width: number): LayoutType {

    if(width < LayoutBreakPoint.SMALL) return LayoutType.SMALL;
    if(width < LayoutBreakPoint.MEDIUM) return LayoutType.MEDIUM;
    if(width < LayoutBreakPoint.LARGE) return LayoutType.LARGE;
    //return LayoutType.XLARGE;
    return LayoutType.LARGE; // Hint: Belimo's max layout is LayoutType.LARGE;
  }

  public static getLayoutWidth(layoutType: LayoutType): number {
    switch(layoutType) {
      case LayoutType.SMALL: return LayoutBreakPoint.DYNAMIC;
      case LayoutType.MEDIUM: return LayoutBreakPoint.SMALL;
      case LayoutType.LARGE: return LayoutBreakPoint.MEDIUM;
      case LayoutType.XLARGE: return LayoutBreakPoint.LARGE;
    }
  }

  public static getUsableWith(layoutType: LayoutType): number {
    switch(layoutType) {
      case LayoutType.SMALL: return LayoutBreakPoint.DYNAMIC;
      case LayoutType.MEDIUM: return LayoutBreakPoint.SMALL;
      case LayoutType.LARGE: return LayoutBreakPoint.MEDIUM + widthCorrection;
      case LayoutType.XLARGE: return LayoutBreakPoint.LARGE + widthCorrection;
    }
  }

  public static getPrimaryMainWidth(layoutType: LayoutType): number {
    switch(layoutType) {
      case LayoutType.SMALL: return 0;
      case LayoutType.MEDIUM: return (this.getUsableWith(layoutType) - (2 * this.getGlobalMarginH(layoutType)));
      case LayoutType.LARGE: return (this.getUsableWith(layoutType) - 256 - (2 * this.getGlobalMarginH(layoutType)));
      case LayoutType.XLARGE: return (this.getUsableWith(layoutType) - 256 - (2 * this.getGlobalMarginH(layoutType)));
    }
  }
}
